// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Except from "../Control.Monad.Except/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_List_NonEmpty from "../Data.List.NonEmpty/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Number from "../Data.Number/index.js";
import * as Data_Rational_Extra from "../Data.Rational.Extra/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Common_Translations_Keys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic_I18n_Types from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic_Locales from "../Restaumatic.Locales/index.js";
var encodeJSON = /* #__PURE__ */ Foreign_Generic.encodeJSON(Foreign_Generic_Class.foreignEncode);
var decodeJSON = /* #__PURE__ */ Foreign_Generic.decodeJSON(Foreign_Generic_Class.foreignDecode);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var map = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var editAsStringValue = {
    toString: function (v) {
        return encodeJSON(v);
    },
    parse: function (str) {
        var v = Control_Monad_Except.runExcept(decodeJSON(str));
        if (v instanceof Data_Either.Left) {
            return new Data_Either.Left(Foreign.renderForeignError(Data_List_NonEmpty.head(v.value0)));
        };
        if (v instanceof Data_Either.Right) {
            return new Data_Either.Right(v.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Form.EditAsString (line 63, column 5 - line 65, column 33): " + [ v.constructor.name ]);
    }
};
var editAsStringString = /* #__PURE__ */ (function () {
    return {
        toString: Control_Category.identity(Control_Category.categoryFn),
        parse: Data_Either.Right.create
    };
})();
var editAsStringRational = {
    toString: Data_Rational_Extra.toString,
    parse: function (s) {
        return Data_Either.note(Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.invalid_rational))(Data_Rational_Extra.fromString(s));
    }
};
var editAsStringNumber = {
    toString: /* #__PURE__ */ Data_Show.show(Data_Show.showNumber),
    parse: function (s) {
        return Data_Either.note(Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.invalid_number))(Data_Number.fromString(s));
    }
};
var editAsStringMoney = {
    toString: Data_Money_Rounded.toString,
    parse: function (s) {
        return Data_Either.note(Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.invalid_money))(Data_Money_Rounded.fromString(s));
    }
};
var editAsStringInt = {
    toString: /* #__PURE__ */ Data_Show.show(Data_Show.showInt),
    parse: function (s) {
        return Data_Either.note(Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.invalid_int))(Data_Int.fromString(s));
    }
};
var toString = function (dict) {
    return dict.toString;
};
var parse = function (dict) {
    return dict.parse;
};
var parse1 = /* #__PURE__ */ parse(editAsStringString);
var editAsStringMaybe = function (dictEditAsString) {
    var parse2 = parse(dictEditAsString);
    return {
        toString: Data_Maybe.maybe("")(toString(dictEditAsString)),
        parse: function (v) {
            if (v === "") {
                return pure(Data_Maybe.Nothing.value);
            };
            return map(Data_Maybe.Just.create)(parse2(v));
        }
    };
};
var editAsStringTranslatedStr = /* #__PURE__ */ (function () {
    return {
        toString: Restaumatic_I18n_Types.getLocalizationOrEmpty(Restaumatic_Locales.PL.value),
        parse: function (s) {
            return map(Restaumatic_I18n_Types.singletonTranslated(Restaumatic_Locales.PL.value))(parse1(s));
        }
    };
})();
export {
    parse,
    toString,
    editAsStringString,
    editAsStringInt,
    editAsStringNumber,
    editAsStringRational,
    editAsStringMoney,
    editAsStringMaybe,
    editAsStringTranslatedStr,
    editAsStringValue
};
